<app-loader [isBusy]="!model || isBusy">
    <ng-template>
        <app-action-bar [items]="actionBar" [collapsed]="false"></app-action-bar>
        <app-content-header [title]="title" [breadcrumb]="breadcrumb"></app-content-header>
        <div class="row">        
            <div class="col-12">
                <div class="card card-border-top">
                    <h4 class="card-title"><fa-icon icon="ship"></fa-icon> {{'GENERAL DATA' | translate}}</h4>
                    <div class="card-body">
                        <app-general-data-segment [model]="model" [editMode]="editMode"/>                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4" *ngIf="model.documentTypeId === VesselVisitDocumentTypeCodes.OP || model.documentTypeId === VesselVisitDocumentTypeCodes.AR">        
            <div class="col-12">
                <div class="card card-border-top">
                    <h4 class="card-title"><fa-icon icon="ship"></fa-icon> {{'ACCOMMODATION REQUEST DATA' | translate}}</h4>
                    <div class="card-body">
                        <app-accommodation-request-segment [model]="model" [editMode]="editMode"/>                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">        
            <div class="col-12">
                <div class="card card-border-top">
                    <h4 class="card-title"><fa-icon icon="ship"></fa-icon> {{'APPROVAL HISTORY DATA' | translate}}</h4>
                    <div class="card-body">                        
                        <ng-container *ngIf="model.documentTypeId === VesselVisitDocumentTypeCodes.OP">
                            <app-operational-plan-approvals-history-segment [model]="model"/>
                        </ng-container>

                        <ng-container *ngIf="model.documentTypeId === VesselVisitDocumentTypeCodes.AR">
                            <app-accommodation-request-approvals-history-segment [model]="model"/>
                        </ng-container>

                        <ng-container *ngIf="model.documentTypeId !== VesselVisitDocumentTypeCodes.OP && model.documentTypeId !== VesselVisitDocumentTypeCodes.AR">
                            <app-approvals-history-segment [model]="model"/>
                        </ng-container>                    
                    </div>
                </div>
            </div>
        </div>        
        <div class="row mt-4" *ngIf="model.documentTypeId === VesselVisitDocumentTypeCodes.OP">        
            <div class="col-12">
                <div class="card card-border-top">
                    <h4 class="card-title"><fa-icon icon="ship"></fa-icon> {{'RECEIPT CONFIRMATION DATA' | translate}}</h4>
                    <div class="card-body">
                        <app-receipt-confirmation-segment [model]="model"/>                        
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">        
            <div class="col-12">
                <kendo-tabstrip>
                    <kendo-tabstrip-tab *ngIf="this.model.documentTypeId===VesselVisitDocumentTypeCodes.AR" title="{{'BERTH PROPOSALS' | translate}}">
                        <ng-template kendoTabContent>
                            <app-proposed-berth-grid [model]="model" [editMode]="editMode" collectionName="berthProposals"/>
                        </ng-template>
                    </kendo-tabstrip-tab>
                    <kendo-tabstrip-tab title="{{'ATTACHMENTS' | translate}}">
                        <ng-template kendoTabContent>
                            <app-documents-grid [model]="model" [editMode]="editMode" collectionName="attachments" [isAddButtonDisabled]="isAddAttachmentDisabled"/>
                        </ng-template>
                    </kendo-tabstrip-tab>                    
                </kendo-tabstrip>
            </div>
        </div>
    </ng-template>
</app-loader>




